import React, { Component } from 'react';
import DatesSelector from './dates-selector';
import DeviceSelector from './device-selector';

type Props = {
  analytics: any;
  spotId: string;
  textHeader: string;
  loading: boolean;
  dateChange: Function;
  deviceChange: Function;
};

const AnalyticsHeader: React.FC<Props> = ({
  analytics,
  spotId,
  textHeader,
  loading,
  dateChange,
  deviceChange
}) => (
  <div className="analytics-header">
    <span className="analytics-title">{textHeader}</span>
    {analytics ? (
      <DatesSelector
        loading={loading}
        dateChange={dateChange}
        spotId={spotId}
        analytics={analytics}
      />
    ) : null}
    {analytics ? (
      <DeviceSelector dateChange={deviceChange} spotId={spotId} analytics={analytics} />
    ) : null}
  </div>
);

export default AnalyticsHeader;
